import { Trans, useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';

import FloatingMessage from '../../FloatingMessage';
import useOutOfFocusNotification from './vm';
import { i18nNS } from '../../../i18n';
import ArrowBackIcon from '../../../icons/ArrowBackIcon';
import ArrowForwardIcon from '../../../icons/ArrowForwardIcon';
import Typography from '../../Typography';
import { StyledKey } from './styles';

const ArrowBack = () => {
  return (
    <StyledKey>
      <ArrowBackIcon size={16} />
    </StyledKey>
  );
};
const ArrowForward = () => {
  return (
    <StyledKey>
      <ArrowForwardIcon size={16} />
    </StyledKey>
  );
};

const OutOfFocusNotification = () => {
  const { t } = useTranslation([i18nNS.COMMON]);

  const { isVisible } = useOutOfFocusNotification();
  return (
    <FloatingMessage visible={isVisible}>
      <Typography
        variant="paragraphRegular"
        color="common.white"
        component={Stack}
        direction="row"
        alignItems="center"
        gap={1.25}
      >
        <Trans
          t={t}
          ns={i18nNS.COMMON}
          i18nKey="press_arrow_key_left_icon_arrow_key_right_icon_to_navigate_between_slides"
        >
          Press <ArrowBack /> <ArrowForward /> to navigate between slides.
        </Trans>
      </Typography>
    </FloatingMessage>
  );
};

export default OutOfFocusNotification;
